import { DELIVERY_ADDRESSES_SET_ERROR } from "./DeliveryAddressesActionTypes";

export const setDeliveryAddressesErrorAction =
  (message: string | null) => (dispatch: any) => {
    dispatch({
      type: DELIVERY_ADDRESSES_SET_ERROR,
      payload: { message },
    });
  };
